

// // // src/pages/RegisterWithCommunity.jsx
// // import React, { useMemo, useState } from "react";
// // import {
// //   Container,
// //   Form,
// //   Button,
// //   Alert,
// //   Spinner,
// //   Card,
// //   Row,
// //   Col,
// // } from "react-bootstrap";
// // import { useNavigate } from "react-router-dom";
// // import { auth, db } from "../firebase";
// // import {
// //   doc,
// //   getDoc,
// //   runTransaction,
// //   Timestamp,
// //   setDoc,
// // } from "firebase/firestore";
// // import {
// //   createUserWithEmailAndPassword,
// //   deleteUser,
// //   signOut,
// //   sendEmailVerification,
// //   updateProfile,
// // } from "firebase/auth";

// // /** ---------- Utils ---------- **/
// // const fetchCommunityById = async (communityId) => {
// //   const id = (communityId || "").trim();
// //   if (!id) throw new Error("Please enter a Community ID.");
// //   const ref = doc(db, "communities", id);
// //   const snap = await getDoc(ref);
// //   if (!snap.exists()) {
// //     const err = new Error("Community not found. Check the ID and try again.");
// //     err.code = "community/not-found";
// //     throw err;
// //   }
// //   return { id, data: snap.data() };
// // };

// // const deriveFromStartNumber = (startNumberInput) => {
// //   const s = String(startNumberInput || "").replace(/\D/g, "");
// //   if (!s) return { floorBase: 1, indexStart: 1, indexWidth: 2 };
// //   if (s.length <= 2) {
// //     const indexStart = parseInt(s, 10);
// //     const indexWidth = Math.max(2, s.length);
// //     return { floorBase: 1, indexStart, indexWidth };
// //   }
// //   const floorBase = parseInt(s.slice(0, -2), 10);
// //   const indexStart = parseInt(s.slice(-2), 10);
// //   return { floorBase, indexStart, indexWidth: 2 };
// // };

// // const buildFloorLabels = (block) => {
// //   const labels = [];
// //   if (block.hasGround)
// //     labels.push({ label: `Ground (${block.groundLabel})`, floorNumber: 0 });
// //   for (let f = 1; f <= Number(block.floors || 0); f++) {
// //     labels.push({ label: `Floor ${f}`, floorNumber: f });
// //   }
// //   return labels;
// // };

// // const buildFlatsForFloor = (block, floorNumber) => {
// //   const { floorBase, indexStart, indexWidth } = deriveFromStartNumber(
// //     block.startNumberInput || "101"
// //   );
// //   const count = Number(block.flatsPerFloor || 0);
// //   const out = [];

// //   if (floorNumber === 0) {
// //     for (let i = 0; i < count; i++) {
// //       const idx = indexStart + i;
// //       out.push(
// //         `${block.name}-${block.groundLabel}${String(idx).padStart(indexWidth, "0")}`
// //       );
// //     }
// //     return out;
// //   }

// //   const floorCode = floorBase + (floorNumber - 1);
// //   for (let i = 0; i < count; i++) {
// //     const idx = indexStart + i;
// //     out.push(`${block.name}-${floorCode}${String(idx).padStart(indexWidth, "0")}`);
// //   }
// //   return out;
// // };

// // /** ---------- Component ---------- **/
// // const IMAGE_URL =
// //   "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

// // async function sendVerificationWithLogs(user, communityId, fullName) {
// //   if (fullName?.trim()) {
// //     try {
// //       await updateProfile(user, { displayName: fullName.trim() });
// //       console.log("[verify] displayName set:", fullName.trim());
// //     } catch (e) {
// //       console.warn("[verify] updateProfile failed:", e);
// //     }
// //   }

// //   const actionCodeSettings = {
// //     url: `${window.location.origin}/verify-success?community=${communityId}`,
// //     handleCodeInApp: false,
// //   };

// //   try {
// //     console.log(
// //       "[verify] sending email to:",
// //       user.email,
// //       "with continueUrl:",
// //       actionCodeSettings.url
// //     );
// //     await sendEmailVerification(user, actionCodeSettings);
// //     console.log("[verify] sendEmailVerification SUCCESS for:", user.email);
// //     return true;
// //   } catch (e) {
// //     console.error("[verify] sendEmailVerification FAILED:", e?.code, e?.message, e);
// //     return false;
// //   }
// // }

// // export default function RegisterWithCommunity() {
// //   const [communityId, setCommunityId] = useState("");
// //   const [community, setCommunity] = useState(null);
// //   const [fetching, setFetching] = useState(false);
// //   const [fetchError, setFetchError] = useState("");

// //   const [showRegisterForm, setShowRegisterForm] = useState(false);

// //   const [selectedBlockId, setSelectedBlockId] = useState("");
// //   const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
// //   const [selectedFlatLabel, setSelectedFlatLabel] = useState("");

// //   const [availableFlats, setAvailableFlats] = useState([]);
// //   const [availLoading, setAvailLoading] = useState(false);

// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [fullName, setFullName] = useState("");
// //   const [mobile, setMobile] = useState("");

// //   const [agreed, setAgreed] = useState(false);

// //   const [registerError, setRegisterError] = useState("");
// //   const [registering, setRegistering] = useState(false);

// //   const navigate = useNavigate();

// //   const handleFetch = async () => {
// //     setFetchError("");
// //     setCommunity(null);
// //     setShowRegisterForm(false);

// //     setSelectedBlockId("");
// //     setSelectedFloorNumber(null);
// //     setSelectedFlatLabel("");
// //     setAvailableFlats([]);

// //     const id = communityId.trim();
// //     if (!id) {
// //       setFetchError("Please enter a Community ID.");
// //       return;
// //     }

// //     try {
// //       setFetching(true);
// //       const result = await fetchCommunityById(id);
// //       setCommunity(result);
// //     } catch (err) {
// //       console.error("Fetch community error:", err.code, err.message);
// //       setFetchError(err.message || "Unable to fetch community.");
// //     } finally {
// //       setFetching(false);
// //     }
// //   };

// //   const handleProceedToRegister = () => {
// //     setShowRegisterForm(true);
// //     setRegisterError("");
// //   };

// //   const blocks = useMemo(() => {
// //     if (!community?.data?.blocks || !Array.isArray(community.data.blocks))
// //       return [];
// //     return community.data.blocks;
// //   }, [community]);

// //   const floorOptions = useMemo(() => {
// //     const block = blocks.find((b) => b.id === selectedBlockId);
// //     if (!block) return [];
// //     return buildFloorLabels(block);
// //   }, [blocks, selectedBlockId]);

// //   const refreshAvailableFlats = async () => {
// //     setAvailableFlats([]);
// //     setSelectedFlatLabel("");
// //     setAvailLoading(true);
// //     try {
// //       const block = blocks.find((b) => b.id === selectedBlockId);
// //       if (!block || selectedFloorNumber === null) return;

// //       const all = buildFlatsForFloor(block, selectedFloorNumber);
// //       const occupancy = block.occupancy || {};
// //       const avail = all.filter((label) => !occupancy[label]);
// //       setAvailableFlats(avail);
// //     } finally {
// //       setAvailLoading(false);
// //     }
// //   };

// //   const handleRegister = async () => {
// //     setRegisterError("");

// //     if (!community?.id) return setRegisterError("Please fetch your community first.");
// //     if (!selectedBlockId) return setRegisterError("Please select a block.");
// //     if (selectedFloorNumber === null) return setRegisterError("Please select a floor.");
// //     if (!selectedFlatLabel) return setRegisterError("Please select a flat number.");
// //     if (!email || !password) return setRegisterError("Please enter email and password.");
// //     if (!agreed) return setRegisterError("Please agree to the terms to continue.");

// //     const block = blocks.find((b) => b.id === selectedBlockId);
// //     if (!block) return setRegisterError("Invalid block selection.");

// //     try {
// //       setRegistering(true);

// //       // 1) Create auth user
// //       const { user } = await createUserWithEmailAndPassword(
// //         auth,
// //         email.trim(),
// //         password
// //       );
// //       console.log("[register] created user:", user.uid, user.email);

// //       // 2) Claim flat in a transaction
// //       const communityRef = doc(db, "communities", community.id);
// //       await runTransaction(db, async (t) => {
// //         const snap = await t.get(communityRef);
// //         if (!snap.exists()) throw new Error("Community not found during claim.");
// //         const data = snap.data();
// //         const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
// //         const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
// //         if (idx < 0) throw new Error("Selected block not found.");

// //         const target = { ...blocksArr[idx] };
// //         const occupancy = { ...(target.occupancy || {}) };
// //         if (occupancy[selectedFlatLabel]) {
// //           throw new Error("Selected flat is already occupied. Please choose another flat.");
// //         }

// //         occupancy[selectedFlatLabel] = user.uid;
// //         target.occupancy = occupancy;
// //         blocksArr[idx] = target;

// //         t.update(communityRef, { blocks: blocksArr });
// //       });
// //       console.log("[register] claimed flat:", selectedFlatLabel, "in block:", block.name);

// //       // 3) Save user profile (Firestore)
// //       const userRef = doc(db, "users", user.uid);
// //       const userSnap = await getDoc(userRef);
// //       const existing = userSnap.exists() ? userSnap.data() : {};
// //       const communities = Array.isArray(existing.communities)
// //         ? Array.from(new Set([...existing.communities, community.id]))
// //         : [community.id];

// //       await setDoc(
// //         userRef,
// //         {
// //           uid: user.uid,
// //           role: "resident",
// //           email: email.trim(),
// //           fullName: fullName.trim() || null,
// //           mobile: mobile.trim() || null,
// //           communities,
// //           unit: {
// //             communityId: community.id,
// //             blockName: block.name,
// //             floorNumber: selectedFloorNumber,
// //             flatLabel: selectedFlatLabel,
// //           },
// //           status: "pending",
// //           profileCompleted: true,
// //           authProvider: "password",
// //           createdAt: Timestamp.now(),
// //         },
// //         { merge: true }
// //       );
// //       console.log("[register] saved profile in Firestore for", user.uid);

// //       // 4) Send the verification email
// //       const ok = await sendVerificationWithLogs(user, community.id, fullName);
// //       if (!ok) {
// //         setRegisterError(
// //           "We couldn’t send the verification email. Please use 'Resend verification' or check your spam folder."
// //         );
// //       }

// //       // 5) Navigate to Check Email page (public route)
// //       navigate(
// //         `/check-email?community=${encodeURIComponent(community.id)}&email=${encodeURIComponent(
// //           email.trim()
// //         )}`
// //       );
// //     } catch (err) {
// //       console.error("Register error:", err.code, err.message, err);
// //       // cleanup newly created auth user on failure
// //       if (auth.currentUser) {
// //         try {
// //           await deleteUser(auth.currentUser);
// //         } catch (cleanupErr) {
// //           console.warn("Could not delete newly created user:", cleanupErr);
// //         }
// //         await signOut(auth).catch(() => { });
// //       }
// //       setRegisterError(err?.message || "Registration failed. Please try again.");
// //     } finally {
// //       setRegistering(false);
// //     }
// //   };

// //   const resetCommunity = () => {
// //     setCommunity(null);
// //     setCommunityId("");
// //     setFetchError("");
// //     setShowRegisterForm(false);

// //     setSelectedBlockId("");
// //     setSelectedFloorNumber(null);
// //     setSelectedFlatLabel("");
// //     setAvailableFlats([]);

// //     setEmail("");
// //     setPassword("");
// //     setFullName("");
// //     setMobile("");
// //     setAgreed(false);
// //     setRegisterError("");
// //   };

// //   return (
// //     <Container className="py-4 py-md-5" style={{ minHeight: "100vh" }}>
// //       <Row className="justify-content-center">
// //         <Col xs={12} lg={10} xl={9}>
// //           <Card className="overflow-hidden shadow register-card rounded-4">
// //             <Row className="g-0">
// //               {/* Left visual */}
// //               <Col md={5} className="d-none d-md-block">
// //                 <div className="register-visual h-100">
// //                   <img
// //                     src={IMAGE_URL}
// //                     alt="Welcome to your community"
// //                     className="register-visual-img"
// //                   />
// //                   <div className="register-visual-overlay">
// //                     <div className="register-visual-text">
// //                       <h2 className="mb-1">Join your community</h2>
// //                       <p className="mb-0">Simple registration. Secure access.</p>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </Col>

// //               {/* Right form */}
// //               <Col xs={12} md={7}>
// //                 <Card.Body className="p-3 p-md-4">
// //                   <h2 className="mb-1">Resident Registration</h2>
// //                   <p className="text-muted mb-4">
// //                     Find your community, pick your flat, and create your account.
// //                   </p>

// //                   {/* Step 1 */}
// //                   <section className="mb-4 pb-3 border-bottom">
// //                     <h5 className="mb-3">Step 1: Identify Your Community</h5>

// //                     {fetchError && <Alert variant="danger">{fetchError}</Alert>}

// //                     {!community ? (
// //                       <>
// //                         <Form.Group className="mb-3">
// //                           <Form.Label>Community ID</Form.Label>
// //                           <Form.Control
// //                             type="text"
// //                             placeholder="e.g., ABC12345"
// //                             value={communityId}
// //                             onChange={(e) => setCommunityId(e.target.value.toUpperCase())}
// //                           />
// //                         </Form.Group>

// //                         <Button className="primary-cta" onClick={handleFetch} disabled={fetching}>
// //                           {fetching ? (
// //                             <>
// //                               <Spinner animation="border" size="sm" className="me-2" /> Fetching…
// //                             </>
// //                           ) : (
// //                             "Fetch"
// //                           )}
// //                         </Button>
// //                       </>
// //                     ) : (
// //                       <>
// //                         <Alert variant="info">
// //                           <div>
// //                             <strong>Community ID:</strong> <code>{community.id}</code>
// //                           </div>
// //                           <div>
// //                             <strong>Name:</strong> {community.data.name}
// //                           </div>
// //                           <div>
// //                             <strong>Address:</strong> {community.data.address}
// //                           </div>
// //                           {community.data.description && (
// //                             <div>
// //                               <strong>Description:</strong> {community.data.description}
// //                             </div>
// //                           )}
// //                         </Alert>
// //                         <div className="d-flex gap-2">
// //                           <Button variant="outline-secondary" onClick={resetCommunity}>
// //                             Check another Community
// //                           </Button>
// //                           <Button className="primary-cta" onClick={handleProceedToRegister}>
// //                             Proceed to Register
// //                           </Button>
// //                         </div>
// //                       </>
// //                     )}
// //                   </section>

// //                   {/* Step 2 */}
// //                   {community && showRegisterForm && (
// //                     <section>
// //                       <h5 className="mb-3">Step 2: Choose Block / Floor / Flat</h5>

// //                       <Row className="g-2">
// //                         {/* Block */}
// //                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                           <Form.Label>Block</Form.Label>
// //                           <Form.Select
// //                             value={selectedBlockId}
// //                             onChange={(e) => {
// //                               setSelectedBlockId(e.target.value);
// //                               setSelectedFloorNumber(null);
// //                               setSelectedFlatLabel("");
// //                               setAvailableFlats([]);
// //                             }}
// //                           >
// //                             <option value="">Select block</option>
// //                             {blocks.map((b) => (
// //                               <option key={b.id} value={b.id}>
// //                                 {b.name} - Block
// //                               </option>
// //                             ))}
// //                           </Form.Select>
// //                         </Form.Group>

// //                         {/* Floor */}
// //                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                           <Form.Label>Floor</Form.Label>
// //                           <Form.Select
// //                             value={selectedFloorNumber ?? ""}
// //                             disabled={!selectedBlockId}
// //                             onChange={(e) => {
// //                               const val =
// //                                 e.target.value === "" ? null : Number(e.target.value);
// //                               setSelectedFloorNumber(val);
// //                               setSelectedFlatLabel("");
// //                               setAvailableFlats([]);
// //                             }}
// //                             onBlur={refreshAvailableFlats}
// //                             onFocus={() => {
// //                               if (selectedBlockId && selectedFloorNumber !== null)
// //                                 refreshAvailableFlats();
// //                             }}
// //                           >
// //                             <option value="">Select floor</option>
// //                             {floorOptions.map(({ label, floorNumber }) => (
// //                               <option key={`floor-${floorNumber}`} value={floorNumber}>
// //                                 {label}
// //                               </option>
// //                             ))}
// //                           </Form.Select>
// //                           <Form.Text muted>
// //                             Ground availability uses the same numbering pattern as upper floors.
// //                           </Form.Text>
// //                         </Form.Group>

// //                         {/* Flat */}
// //                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                           <Form.Label>Flat number</Form.Label>
// //                           <Form.Select
// //                             value={selectedFlatLabel}
// //                             disabled={!selectedBlockId || selectedFloorNumber === null}
// //                             onFocus={refreshAvailableFlats}
// //                             onChange={(e) => setSelectedFlatLabel(e.target.value)}
// //                           >
// //                             <option value="">
// //                               {availLoading ? "Checking availability…" : "Select available flat"}
// //                             </option>
// //                             {!availLoading &&
// //                               availableFlats.map((label) => (
// //                                 <option key={label} value={label}>
// //                                   {label}
// //                                 </option>
// //                               ))}
// //                           </Form.Select>
// //                         </Form.Group>
// //                       </Row>

// //                       <hr />

// //                       {/* Account info */}
// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Full name (optional)</Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           value={fullName}
// //                           onChange={(e) => setFullName(e.target.value)}
// //                           placeholder="e.g., Rahul Sharma"
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Mobile (optional)</Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           value={mobile}
// //                           onChange={(e) => setMobile(e.target.value)}
// //                           placeholder="e.g., 9876543210"
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Email</Form.Label>
// //                         <Form.Control
// //                           type="email"
// //                           autoComplete="username"
// //                           placeholder="name@example.com"
// //                           value={email}
// //                           onChange={(e) => setEmail(e.target.value)}
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Password</Form.Label>
// //                         <Form.Control
// //                           type="password"
// //                           autoComplete="new-password"
// //                           placeholder="Enter a strong password"
// //                           value={password}
// //                           onChange={(e) => setPassword(e.target.value)}
// //                         />
// //                       </Form.Group>

// //                       {/* ✅ Terms */}
// //                       <Form.Group className="mb-3">
// //                         <Form.Check
// //                           id="agree-terms"
// //                           type="checkbox"
// //                           label="I agree to the Terms & Privacy Policy."
// //                           checked={agreed}
// //                           onChange={(e) => setAgreed(e.target.checked)}
// //                         />
// //                       </Form.Group>

// //                       {registerError && (
// //                         <Alert variant="danger" className="mb-3">
// //                           {registerError}
// //                         </Alert>
// //                       )}

// //                       <div className="register-action-bar">
// //                         <Button className="primary-cta" onClick={handleRegister} disabled={registering}>
// //                           {registering ? (
// //                             <>
// //                               <Spinner animation="border" size="sm" className="me-2" /> Registering…
// //                             </>
// //                           ) : (
// //                             "Register"
// //                           )}
// //                         </Button>
// //                       </div>
// //                     </section>
// //                   )}

// //                   <p className="mt-4 mb-0 text-muted">Your safety is our prime priority.</p>
// //                 </Card.Body>
// //               </Col>
// //             </Row>
// //           </Card>
// //         </Col>
// //       </Row>
// //     </Container>
// //   );
// // }

// // src/pages/RegisterWithCommunity.jsx

// import React, { useMemo, useState } from "react";
// import {
//   Container,
//   Form,
//   Button,
//   Alert,
//   Spinner,
//   Card,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import { auth, db } from "../firebase";

// import {
//   doc,
//   getDoc,
//   runTransaction,
//   Timestamp,
// } from "firebase/firestore";

// import {
//   createUserWithEmailAndPassword,
//   deleteUser,
//   signOut,
//   sendEmailVerification,
//   updateProfile,
//   GoogleAuthProvider,
//   signInWithPopup,
//   getAdditionalUserInfo,
// } from "firebase/auth";

// const IMAGE_URL =
//   "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

// const googleProvider = new GoogleAuthProvider();

// googleProvider.setCustomParameters({
//   prompt: "select_account",
// });

// const fetchCommunityById = async (communityId) => {
//   const id = String(communityId || "").trim();

//   if (!id) {
//     throw new Error("Please enter a Community ID.");
//   }

//   const communityRef = doc(db, "communities", id);
//   const communitySnapshot = await getDoc(communityRef);

//   if (!communitySnapshot.exists()) {
//     const error = new Error(
//       "Community not found. Check the ID and try again."
//     );
//     error.code = "community/not-found";
//     throw error;
//   }

//   return {
//     id,
//     data: communitySnapshot.data(),
//   };
// };

// const deriveFromStartNumber = (startNumberInput) => {
//   const value = String(startNumberInput || "").replace(/\D/g, "");

//   if (!value) {
//     return {
//       floorBase: 1,
//       indexStart: 1,
//       indexWidth: 2,
//     };
//   }

//   if (value.length <= 2) {
//     return {
//       floorBase: 1,
//       indexStart: parseInt(value, 10),
//       indexWidth: Math.max(2, value.length),
//     };
//   }

//   return {
//     floorBase: parseInt(value.slice(0, -2), 10),
//     indexStart: parseInt(value.slice(-2), 10),
//     indexWidth: 2,
//   };
// };

// const buildFloorLabels = (block) => {
//   const labels = [];

//   if (block.hasGround) {
//     labels.push({
//       label: `Ground (${block.groundLabel})`,
//       floorNumber: 0,
//     });
//   }

//   for (let floor = 1; floor <= Number(block.floors || 0); floor += 1) {
//     labels.push({
//       label: `Floor ${floor}`,
//       floorNumber: floor,
//     });
//   }

//   return labels;
// };

// const buildFlatsForFloor = (block, floorNumber) => {
//   const {
//     floorBase,
//     indexStart,
//     indexWidth,
//   } = deriveFromStartNumber(block.startNumberInput || "101");

//   const count = Number(block.flatsPerFloor || 0);
//   const flats = [];

//   if (floorNumber === 0) {
//     for (let index = 0; index < count; index += 1) {
//       const flatIndex = indexStart + index;

//       flats.push(
//         `${block.name}-${block.groundLabel}${String(flatIndex).padStart(
//           indexWidth,
//           "0"
//         )}`
//       );
//     }

//     return flats;
//   }

//   const floorCode = floorBase + (floorNumber - 1);

//   for (let index = 0; index < count; index += 1) {
//     const flatIndex = indexStart + index;

//     flats.push(
//       `${block.name}-${floorCode}${String(flatIndex).padStart(
//         indexWidth,
//         "0"
//       )}`
//     );
//   }

//   return flats;
// };

// const getAuthErrorMessage = (error) => {
//   switch (error?.code) {
//     case "auth/email-already-in-use":
//       return "This email is already registered. Please log in instead.";

//     case "auth/invalid-email":
//       return "Please enter a valid email address.";

//     case "auth/weak-password":
//       return "Password must contain at least 6 characters.";

//     case "auth/popup-closed-by-user":
//       return "Google registration was cancelled before completion.";

//     case "auth/popup-blocked":
//       return "The Google popup was blocked. Allow popups and try again.";

//     case "auth/cancelled-popup-request":
//       return "Another Google sign-in popup is already open.";

//     case "auth/account-exists-with-different-credential":
//       return "An account already exists with this email using another sign-in method.";

//     case "auth/network-request-failed":
//       return "Network error. Check your internet connection and try again.";

//     case "auth/unauthorized-domain":
//       return "This domain is not authorized in Firebase Authentication.";

//     default:
//       return error?.message || "Registration failed. Please try again.";
//   }
// };

// async function sendVerificationEmail(user, communityId, fullName) {
//   if (fullName?.trim()) {
//     try {
//       await updateProfile(user, {
//         displayName: fullName.trim(),
//       });
//     } catch (error) {
//       console.warn("Unable to update Firebase display name:", error);
//     }
//   }

//   const actionCodeSettings = {
//     url: `${window.location.origin}/verify-success?community=${encodeURIComponent(
//       communityId
//     )}`,
//     handleCodeInApp: false,
//   };

//   await sendEmailVerification(user, actionCodeSettings);
// };

// export default function RegisterWithCommunity() {
//   const [communityId, setCommunityId] = useState("");
//   const [community, setCommunity] = useState(null);
//   const [fetching, setFetching] = useState(false);
//   const [fetchError, setFetchError] = useState("");

//   const [showRegisterForm, setShowRegisterForm] = useState(false);

//   const [selectedBlockId, setSelectedBlockId] = useState("");
//   const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
//   const [selectedFlatLabel, setSelectedFlatLabel] = useState("");

//   const [availableFlats, setAvailableFlats] = useState([]);
//   const [availLoading, setAvailLoading] = useState(false);

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [fullName, setFullName] = useState("");
//   const [mobile, setMobile] = useState("");

//   const [agreed, setAgreed] = useState(false);

//   const [registerError, setRegisterError] = useState("");
//   const [registering, setRegistering] = useState(false);
//   const [googleRegistering, setGoogleRegistering] = useState(false);

//   const navigate = useNavigate();

//   const blocks = useMemo(() => {
//     if (!Array.isArray(community?.data?.blocks)) {
//       return [];
//     }

//     return community.data.blocks;
//   }, [community]);

//   const floorOptions = useMemo(() => {
//     const block = blocks.find(
//       (currentBlock) => currentBlock.id === selectedBlockId
//     );

//     if (!block) {
//       return [];
//     }

//     return buildFloorLabels(block);
//   }, [blocks, selectedBlockId]);

//   const validateCommunitySelection = () => {
//     if (!community?.id) {
//       throw new Error("Please fetch your community first.");
//     }

//     if (!selectedBlockId) {
//       throw new Error("Please select a block.");
//     }

//     if (selectedFloorNumber === null) {
//       throw new Error("Please select a floor.");
//     }

//     if (!selectedFlatLabel) {
//       throw new Error("Please select a flat number.");
//     }

//     if (!agreed) {
//       throw new Error("Please agree to the Terms and Privacy Policy.");
//     }

//     const selectedBlock = blocks.find(
//       (currentBlock) => currentBlock.id === selectedBlockId
//     );

//     if (!selectedBlock) {
//       throw new Error("Invalid block selection.");
//     }

//     return selectedBlock;
//   };

//   const handleFetch = async () => {
//     setFetchError("");
//     setCommunity(null);
//     setShowRegisterForm(false);

//     setSelectedBlockId("");
//     setSelectedFloorNumber(null);
//     setSelectedFlatLabel("");
//     setAvailableFlats([]);

//     const id = communityId.trim();

//     if (!id) {
//       setFetchError("Please enter a Community ID.");
//       return;
//     }

//     try {
//       setFetching(true);

//       const result = await fetchCommunityById(id);
//       setCommunity(result);
//     } catch (error) {
//       console.error("Fetch community error:", error);
//       setFetchError(error.message || "Unable to fetch community.");
//     } finally {
//       setFetching(false);
//     }
//   };

//   const handleProceedToRegister = () => {
//     setShowRegisterForm(true);
//     setRegisterError("");
//   };

// const refreshAvailableFlats = async (blockId, floorNumber) => {
//   if (!blockId || floorNumber === null || floorNumber === undefined) {
//     setAvailableFlats([]);
//     return;
//   }

//   try {
//     setAvailLoading(true);
//     setRegisterError("");

//     const communityRef = doc(db, "communities", community.id);
//     const communitySnapshot = await getDoc(communityRef);

//     if (!communitySnapshot.exists()) {
//       throw new Error("Community not found.");
//     }

//     const communityData = communitySnapshot.data();

//     const latestBlocks = Array.isArray(communityData.blocks)
//       ? communityData.blocks
//       : [];

//     const block = latestBlocks.find(
//       (currentBlock) => currentBlock.id === blockId
//     );

//     if (!block) {
//       throw new Error("Selected block not found.");
//     }

//     const allFlats = buildFlatsForFloor(block, floorNumber);

//     const occupancy = block.occupancy || {};

//     const available = allFlats.filter(
//       (flatLabel) => !occupancy[flatLabel]
//     );

//     console.log("All flats:", allFlats);
//     console.log("Occupancy:", occupancy);
//     console.log("Available flats:", available);

//     setAvailableFlats(available);
//   } catch (error) {
//     console.error("Flat availability error:", error);

//     setAvailableFlats([]);

//     setRegisterError(
//       error.message || "Unable to load available flats."
//     );
//   } finally {
//     setAvailLoading(false);
//   }
// };

//   const saveResidentAndClaimFlat = async ({
//     user,
//     selectedBlock,
//     authProvider,
//     residentName,
//     residentMobile,
//   }) => {
//     const communityRef = doc(db, "communities", community.id);
//     const userRef = doc(db, "users", user.uid);

//     await runTransaction(db, async (transaction) => {
//       const communitySnapshot = await transaction.get(communityRef);

//       if (!communitySnapshot.exists()) {
//         throw new Error("Community not found during registration.");
//       }

//       const communityData = communitySnapshot.data();

//       const communityBlocks = Array.isArray(communityData.blocks)
//         ? [...communityData.blocks]
//         : [];

//       const blockIndex = communityBlocks.findIndex(
//         (currentBlock) => currentBlock.id === selectedBlockId
//       );

//       if (blockIndex < 0) {
//         throw new Error("Selected block was not found.");
//       }

//       const latestBlock = {
//         ...communityBlocks[blockIndex],
//       };

//       const occupancy = {
//         ...(latestBlock.occupancy || {}),
//       };

//       if (occupancy[selectedFlatLabel]) {
//         throw new Error(
//           "Selected flat is already occupied. Please choose another flat."
//         );
//       }

//       occupancy[selectedFlatLabel] = user.uid;

//       latestBlock.occupancy = occupancy;
//       communityBlocks[blockIndex] = latestBlock;

//       transaction.update(communityRef, {
//         blocks: communityBlocks,
//       });

//       transaction.set(
//         userRef,
//         {
//           uid: user.uid,
//           role: "resident",
//           email: user.email || email.trim(),
//           fullName:
//             residentName?.trim() ||
//             user.displayName ||
//             null,
//           mobile:
//             residentMobile?.trim() ||
//             user.phoneNumber ||
//             null,
//           photoURL: user.photoURL || null,
//           communities: [community.id],
//           unit: {
//             communityId: community.id,
//             blockId: selectedBlockId,
//             blockName: selectedBlock.name,
//             floorNumber: selectedFloorNumber,
//             flatLabel: selectedFlatLabel,
//           },
//           status: "pending",
//           profileCompleted: true,
//           authProvider,
//           emailVerified: user.emailVerified,
//           createdAt: Timestamp.now(),
//           updatedAt: Timestamp.now(),
//         },
//         {
//           merge: true,
//         }
//       );
//     });
//   };

//   const handleEmailRegister = async () => {
//     setRegisterError("");

//     let createdUser = null;
//     let flatClaimed = false;

//     try {
//       const selectedBlock = validateCommunitySelection();

//       if (!email.trim()) {
//         throw new Error("Please enter your email address.");
//       }

//       if (!password) {
//         throw new Error("Please enter your password.");
//       }

//       if (password.length < 6) {
//         throw new Error("Password must contain at least 6 characters.");
//       }

//       setRegistering(true);

//       const userCredential = await createUserWithEmailAndPassword(
//         auth,
//         email.trim(),
//         password
//       );

//       createdUser = userCredential.user;

//       if (fullName.trim()) {
//         await updateProfile(createdUser, {
//           displayName: fullName.trim(),
//         });
//       }

//       await saveResidentAndClaimFlat({
//         user: createdUser,
//         selectedBlock,
//         authProvider: "password",
//         residentName: fullName,
//         residentMobile: mobile,
//       });

//       flatClaimed = true;

//       try {
//         await sendVerificationEmail(
//           createdUser,
//           community.id,
//           fullName
//         );
//       } catch (verificationError) {
//         console.error(
//           "Verification email error:",
//           verificationError
//         );

//         setRegisterError(
//           "Registration completed, but the verification email could not be sent. Use the resend verification option."
//         );
//       }

//       navigate(
//         `/check-email?community=${encodeURIComponent(
//           community.id
//         )}&email=${encodeURIComponent(email.trim())}`
//       );
//     } catch (error) {
//       console.error("Email registration error:", error);

//       if (createdUser && !flatClaimed) {
//         try {
//           await deleteUser(createdUser);
//         } catch (deleteError) {
//           console.warn(
//             "Could not delete the newly created authentication user:",
//             deleteError
//           );
//         }
//       }

//       await signOut(auth).catch(() => {});

//       setRegisterError(getAuthErrorMessage(error));
//     } finally {
//       setRegistering(false);
//     }
//   };

//   const handleGoogleRegister = async () => {
//     setRegisterError("");

//     let googleUser = null;
//     let isNewGoogleUser = false;
//     let registrationCompleted = false;

//     try {
//       const selectedBlock = validateCommunitySelection();

//       setGoogleRegistering(true);

//       const result = await signInWithPopup(
//         auth,
//         googleProvider
//       );

//       googleUser = result.user;

//       const additionalUserInfo = getAdditionalUserInfo(result);
//       isNewGoogleUser = Boolean(
//         additionalUserInfo?.isNewUser
//       );

//       const userRef = doc(db, "users", googleUser.uid);
//       const existingUserSnapshot = await getDoc(userRef);

//       if (existingUserSnapshot.exists()) {
//         const existingUser = existingUserSnapshot.data();

//         if (
//           existingUser.unit?.communityId &&
//           existingUser.unit?.flatLabel
//         ) {
//           throw new Error(
//             "This Google account is already registered with a flat. Please log in instead."
//           );
//         }
//       }

//       await saveResidentAndClaimFlat({
//         user: googleUser,
//         selectedBlock,
//         authProvider: "google",
//         residentName:
//           fullName.trim() || googleUser.displayName || "",
//         residentMobile:
//           mobile.trim() || googleUser.phoneNumber || "",
//       });

//       registrationCompleted = true;

//       navigate("/dashboard");
//     } catch (error) {
//       console.error("Google registration error:", error);

//       if (
//         googleUser &&
//         isNewGoogleUser &&
//         !registrationCompleted
//       ) {
//         try {
//           await deleteUser(googleUser);
//         } catch (deleteError) {
//           console.warn(
//             "Could not delete the new Google authentication user:",
//             deleteError
//           );
//         }
//       }

//       if (
//         error?.message?.includes(
//           "already registered with a flat"
//         )
//       ) {
//         await signOut(auth).catch(() => {});
//       }

//       setRegisterError(getAuthErrorMessage(error));
//     } finally {
//       setGoogleRegistering(false);
//     }
//   };

//   const resetCommunity = () => {
//     setCommunity(null);
//     setCommunityId("");
//     setFetchError("");
//     setShowRegisterForm(false);

//     setSelectedBlockId("");
//     setSelectedFloorNumber(null);
//     setSelectedFlatLabel("");
//     setAvailableFlats([]);

//     setEmail("");
//     setPassword("");
//     setFullName("");
//     setMobile("");
//     setAgreed(false);

//     setRegisterError("");
//   };

//   const isSubmitting =
//     registering || googleRegistering;

//   return (
//     <Container
//       className="py-4 py-md-5"
//       style={{ minHeight: "100vh" }}
//     >
//       <Row className="justify-content-center">
//         <Col xs={12} lg={10} xl={9}>
//           <Card className="overflow-hidden shadow register-card rounded-4">
//             <Row className="g-0">
//               <Col
//                 md={5}
//                 className="d-none d-md-block"
//               >
//                 <div className="register-visual h-100">
//                   {IMAGE_URL}

//                   <div className="register-visual-overlay">
//                     <div className="register-visual-text">
//                       <h2 className="mb-1">
//                         Join your community
//                       </h2>

//                       <p className="mb-0">
//                         Simple registration. Secure access.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </Col>

//               <Col xs={12} md={7}>
//                 <Card.Body className="p-3 p-md-4">
//                   <h2 className="mb-1">
//                     Resident Registration
//                   </h2>

//                   <p className="text-muted mb-4">
//                     Find your community, select your flat,
//                     and create your account.
//                   </p>

//                   <section className="mb-4 pb-3 border-bottom">
//                     <h5 className="mb-3">
//                       Step 1: Identify Your Community
//                     </h5>

//                     {fetchError && (
//                       <Alert variant="danger">
//                         {fetchError}
//                       </Alert>
//                     )}

//                     {!community ? (
//                       <>
//                         <Form.Group className="mb-3">
//                           <Form.Label>
//                             Community ID
//                           </Form.Label>

//                           <Form.Control
//                             type="text"
//                             placeholder="e.g., ABC12345"
//                             value={communityId}
//                             onChange={(event) =>
//                               setCommunityId(
//                                 event.target.value.toUpperCase()
//                               )
//                             }
//                           />
//                         </Form.Group>

//                         <Button
//                           className="primary-cta"
//                           onClick={handleFetch}
//                           disabled={fetching}
//                         >
//                           {fetching ? (
//                             <>
//                               <Spinner
//                                 animation="border"
//                                 size="sm"
//                                 className="me-2"
//                               />
//                               Fetching...
//                             </>
//                           ) : (
//                             "Fetch"
//                           )}
//                         </Button>
//                       </>
//                     ) : (
//                       <>
//                         <Alert variant="info">
//                           <div>
//                             <strong>Community ID:</strong>{" "}
//                             <code>{community.id}</code>
//                           </div>

//                           <div>
//                             <strong>Name:</strong>{" "}
//                             {community.data.name}
//                           </div>

//                           <div>
//                             <strong>Address:</strong>{" "}
//                             {community.data.address}
//                           </div>

//                           {community.data.description && (
//                             <div>
//                               <strong>Description:</strong>{" "}
//                               {community.data.description}
//                             </div>
//                           )}
//                         </Alert>

//                         <div className="d-flex flex-wrap gap-2">
//                           <Button
//                             variant="outline-secondary"
//                             onClick={resetCommunity}
//                             disabled={isSubmitting}
//                           >
//                             Check Another Community
//                           </Button>

//                           <Button
//                             className="primary-cta"
//                             onClick={
//                               handleProceedToRegister
//                             }
//                             disabled={isSubmitting}
//                           >
//                             Proceed to Register
//                           </Button>
//                         </div>
//                       </>
//                     )}
//                   </section>

//                   {community && showRegisterForm && (
//                     <section>
//                       <h5 className="mb-3">
//                         Step 2: Choose Block, Floor and Flat
//                       </h5>

//                       <Row className="g-2">
//                         <Form.Group
//   as={Col}
//   xs={12}
//   md={4}
//   className="mb-3"
// >
//   <Form.Label>Block</Form.Label>

//   <Form.Select
//     value={selectedBlockId}
//     disabled={isSubmitting}
//     onChange={(event) => {
//       const blockId = event.target.value;

//       setSelectedBlockId(blockId);
//       setSelectedFloorNumber(null);
//       setSelectedFlatLabel("");
//       setAvailableFlats([]);
//     }}
//   >
//     <option value="">Select block</option>

//     {blocks.map((block) => (
//       <option
//         key={block.id}
//         value={block.id}
//       >
//         {block.name} - Block
//       </option>
//     ))}
//   </Form.Select>
// </Form.Group>

//                       <Form.Group
//   as={Col}
//   xs={12}
//   md={4}
//   className="mb-3"
// >
//   <Form.Label>Floor</Form.Label>

//   <Form.Select
//     value={selectedFloorNumber ?? ""}
//     disabled={!selectedBlockId || isSubmitting}
//     onChange={async (event) => {
//       const value = event.target.value;

//       if (value === "") {
//         setSelectedFloorNumber(null);
//         setSelectedFlatLabel("");
//         setAvailableFlats([]);
//         return;
//       }

//       const floorNumber = Number(value);

//       setSelectedFloorNumber(floorNumber);
//       setSelectedFlatLabel("");
//       setAvailableFlats([]);

//       await refreshAvailableFlats(
//         selectedBlockId,
//         floorNumber
//       );
//     }}
//   >
//     <option value="">Select floor</option>

//     {floorOptions.map(({ label, floorNumber }) => (
//       <option
//         key={`floor-${floorNumber}`}
//         value={floorNumber}
//       >
//         {label}
//       </option>
//     ))}
//   </Form.Select>
// </Form.Group>

//                       <Form.Group
//   as={Col}
//   xs={12}
//   md={4}
//   className="mb-3"
// >
//   <Form.Label>Flat Number</Form.Label>

//   <Form.Select
//     value={selectedFlatLabel}
//     disabled={
//       !selectedBlockId ||
//       selectedFloorNumber === null ||
//       availLoading ||
//       isSubmitting
//     }
//     onChange={(event) => {
//       setSelectedFlatLabel(event.target.value);
//     }}
//   >
//     <option value="">
//       {availLoading
//         ? "Checking availability..."
//         : availableFlats.length === 0
//         ? "No available flats"
//         : "Select available flat"}
//     </option>

//     {availableFlats.map((flatLabel) => (
//       <option
//         key={flatLabel}
//         value={flatLabel}
//       >
//         {flatLabel}
//       </option>
//     ))}
//   </Form.Select>

//   {!availLoading &&
//     selectedFloorNumber !== null &&
//     availableFlats.length === 0 && (
//       <Form.Text className="text-danger">
//         No flats are currently available on this floor.
//       </Form.Text>
//     )}
// </Form.Group>
//                       </Row>

//                       <hr />

//                       <Form.Group className="mb-3">
//                         <Form.Label>
//                           Full Name
//                         </Form.Label>

//                         <Form.Control
//                           type="text"
//                           value={fullName}
//                           disabled={isSubmitting}
//                           onChange={(event) =>
//                             setFullName(
//                               event.target.value
//                             )
//                           }
//                           placeholder="e.g., Rahul Sharma"
//                         />

//                         <Form.Text muted>
//                           For Google registration, the
//                           Google profile name is used when
//                           this field is empty.
//                         </Form.Text>
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Label>
//                           Mobile
//                         </Form.Label>

//                         <Form.Control
//                           type="tel"
//                           value={mobile}
//                           disabled={isSubmitting}
//                           maxLength={15}
//                           onChange={(event) =>
//                             setMobile(
//                               event.target.value.replace(
//                                 /[^0-9+]/g,
//                                 ""
//                               )
//                             )
//                           }
//                           placeholder="e.g., 9876543210"
//                         />
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Label>Email</Form.Label>

//                         <Form.Control
//                           type="email"
//                           autoComplete="username"
//                           placeholder="name@example.com"
//                           value={email}
//                           disabled={isSubmitting}
//                           onChange={(event) =>
//                             setEmail(
//                               event.target.value
//                             )
//                           }
//                         />
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Label>
//                           Password
//                         </Form.Label>

//                         <Form.Control
//                           type="password"
//                           autoComplete="new-password"
//                           placeholder="Minimum 6 characters"
//                           value={password}
//                           disabled={isSubmitting}
//                           onChange={(event) =>
//                             setPassword(
//                               event.target.value
//                             )
//                           }
//                         />
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Check
//                           id="agree-terms"
//                           type="checkbox"
//                           label="I agree to the Terms and Privacy Policy."
//                           checked={agreed}
//                           disabled={isSubmitting}
//                           onChange={(event) =>
//                             setAgreed(
//                               event.target.checked
//                             )
//                           }
//                         />
//                       </Form.Group>

//                       {registerError && (
//                         <Alert
//                           variant="danger"
//                           className="mb-3"
//                         >
//                           {registerError}
//                         </Alert>
//                       )}

//                       <div className="d-grid gap-3">
//                         <Button
//                           className="primary-cta"
//                           onClick={
//                             handleEmailRegister
//                           }
//                           disabled={isSubmitting}
//                         >
//                           {registering ? (
//                             <>
//                               <Spinner
//                                 animation="border"
//                                 size="sm"
//                                 className="me-2"
//                               />
//                               Registering...
//                             </>
//                           ) : (
//                             "Register with Email"
//                           )}
//                         </Button>

//                         <div className="d-flex align-items-center">
//                           <hr className="flex-grow-1" />
//                           <span className="mx-3 text-muted">
//                             OR
//                           </span>
//                           <hr className="flex-grow-1" />
//                         </div>

//                         <Button
//                           type="button"
//                           variant="outline-danger"
//                           onClick={
//                             handleGoogleRegister
//                           }
//                           disabled={isSubmitting}
//                         >
//                           {googleRegistering ? (
//                             <>
//                               <Spinner
//                                 animation="border"
//                                 size="sm"
//                                 className="me-2"
//                               />
//                               Connecting to Google...
//                             </>
//                           ) : (
//                             "Register with Google"
//                           )}
//                         </Button>
//                       </div>
//                     </section>
//                   )}

//                   <p className="mt-4 mb-0 text-muted">
//                     Your safety is our prime priority.
//                   </p>
//                 </Card.Body>
//               </Col>
//             </Row>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// src/pages/RegisterWithCommunity.jsx

import React, { useMemo, useState } from "react";
import {
  Container,
  Form,
  Button,
  Alert,
  Spinner,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";

import {
  doc,
  getDoc,
  runTransaction,
  Timestamp,
} from "firebase/firestore";

import {
  createUserWithEmailAndPassword,
  deleteUser,
  signOut,
  sendEmailVerification,
  updateProfile,
  GoogleAuthProvider,
  signInWithPopup,
  getAdditionalUserInfo,
} from "firebase/auth";

const IMAGE_URL =
  "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});

const fetchCommunityById = async (communityId) => {
  const id = String(communityId || "").trim();

  if (!id) {
    throw new Error("Please enter a Community ID.");
  }

  const communityRef = doc(db, "communities", id);
  const communitySnapshot = await getDoc(communityRef);

  if (!communitySnapshot.exists()) {
    const error = new Error(
      "Community not found. Check the ID and try again."
    );

    error.code = "community/not-found";

    throw error;
  }

  return {
    id,
    data: communitySnapshot.data(),
  };
};

const deriveFromStartNumber = (startNumberInput) => {
  const value = String(startNumberInput || "").replace(/\D/g, "");

  if (!value) {
    return {
      floorBase: 1,
      indexStart: 1,
      indexWidth: 2,
    };
  }

  if (value.length <= 2) {
    return {
      floorBase: 1,
      indexStart: parseInt(value, 10),
      indexWidth: Math.max(2, value.length),
    };
  }

  return {
    floorBase: parseInt(value.slice(0, -2), 10),
    indexStart: parseInt(value.slice(-2), 10),
    indexWidth: 2,
  };
};

const buildFloorLabels = (block) => {
  const labels = [];

  if (block.hasGround) {
    labels.push({
      label: `Ground (${block.groundLabel || "G"})`,
      floorNumber: 0,
    });
  }

  const totalFloors = Number(block.floors || 0);

  for (
    let floorNumber = 1;
    floorNumber <= totalFloors;
    floorNumber += 1
  ) {
    labels.push({
      label: `Floor ${floorNumber}`,
      floorNumber,
    });
  }

  return labels;
};

const buildFlatsForFloor = (block, floorNumber) => {
  const {
    floorBase,
    indexStart,
    indexWidth,
  } = deriveFromStartNumber(
    block.startNumberInput || "101"
  );

  const count = Number(block.flatsPerFloor || 0);
  const flats = [];

  if (floorNumber === 0) {
    const groundLabel = block.groundLabel || "G";

    for (let index = 0; index < count; index += 1) {
      const flatIndex = indexStart + index;

      flats.push(
        `${block.name}-${groundLabel}${String(
          flatIndex
        ).padStart(indexWidth, "0")}`
      );
    }

    return flats;
  }

  const floorCode =
    floorBase + (floorNumber - 1);

  for (let index = 0; index < count; index += 1) {
    const flatIndex = indexStart + index;

    flats.push(
      `${block.name}-${floorCode}${String(
        flatIndex
      ).padStart(indexWidth, "0")}`
    );
  }

  return flats;
};

const getAuthErrorMessage = (error) => {
  switch (error?.code) {
    case "auth/email-already-in-use":
      return "This email is already registered. Please log in instead.";

    case "auth/invalid-email":
      return "Please enter a valid email address.";

    case "auth/weak-password":
      return "Password must contain at least 6 characters.";

    case "auth/popup-closed-by-user":
      return "Google registration was cancelled.";

    case "auth/popup-blocked":
      return "The Google popup was blocked. Allow popups and try again.";

    case "auth/cancelled-popup-request":
      return "Another Google popup is already open.";

    case "auth/account-exists-with-different-credential":
      return "An account already exists with this email using another sign-in method.";

    case "auth/network-request-failed":
      return "Network error. Check your internet connection and try again.";

    case "auth/unauthorized-domain":
      return "This domain is not authorized in Firebase Authentication.";

    case "auth/operation-not-allowed":
      return "Google registration is not enabled in Firebase Authentication.";

    default:
      return error?.message || "Registration failed. Please try again.";
  }
};

const sendVerificationEmail = async (
  user,
  communityId,
  fullName
) => {
  if (fullName.trim()) {
    await updateProfile(user, {
      displayName: fullName.trim(),
    });
  }

  const actionCodeSettings = {
    url: `${window.location.origin}/verify-success?community=${encodeURIComponent(
      communityId
    )}`,
    handleCodeInApp: false,
  };

  await sendEmailVerification(
    user,
    actionCodeSettings
  );
};

export default function RegisterWithCommunity() {
  const [communityId, setCommunityId] = useState("");
  const [community, setCommunity] = useState(null);

  const [fetching, setFetching] = useState(false);
  const [fetchError, setFetchError] = useState("");

  const [showRegistrationChoice, setShowRegistrationChoice] =
    useState(false);

  const [registrationMethod, setRegistrationMethod] =
    useState("");

  const [selectedBlockId, setSelectedBlockId] =
    useState("");

  const [
    selectedFloorNumber,
    setSelectedFloorNumber,
  ] = useState(null);

  const [selectedFlatLabel, setSelectedFlatLabel] =
    useState("");

  const [availableFlats, setAvailableFlats] =
    useState([]);

  const [availLoading, setAvailLoading] =
    useState(false);

  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [agreed, setAgreed] = useState(false);

  const [registerError, setRegisterError] =
    useState("");

  const [registering, setRegistering] =
    useState(false);

  const [googleRegistering, setGoogleRegistering] =
    useState(false);

  const navigate = useNavigate();

  const blocks = useMemo(() => {
    if (!Array.isArray(community?.data?.blocks)) {
      return [];
    }

    return community.data.blocks;
  }, [community]);

  const floorOptions = useMemo(() => {
    const selectedBlock = blocks.find(
      (block) => block.id === selectedBlockId
    );

    if (!selectedBlock) {
      return [];
    }

    return buildFloorLabels(selectedBlock);
  }, [blocks, selectedBlockId]);

  const isSubmitting =
    registering || googleRegistering;

  const clearFlatSelection = () => {
    setSelectedBlockId("");
    setSelectedFloorNumber(null);
    setSelectedFlatLabel("");
    setAvailableFlats([]);
    setRegisterError("");
  };

  const handleFetch = async () => {
    setFetchError("");
    setRegisterError("");
    setCommunity(null);
    setShowRegistrationChoice(false);
    setRegistrationMethod("");

    clearFlatSelection();

    const id = communityId.trim();

    if (!id) {
      setFetchError("Please enter a Community ID.");
      return;
    }

    try {
      setFetching(true);

      const result =
        await fetchCommunityById(id);

      setCommunity(result);
    } catch (error) {
      console.error(
        "Fetch community error:",
        error
      );

      setFetchError(
        error.message ||
          "Unable to fetch community."
      );
    } finally {
      setFetching(false);
    }
  };

  const handleProceedToRegister = () => {
    setShowRegistrationChoice(true);
    setRegistrationMethod("");
    setRegisterError("");

    clearFlatSelection();

    setFullName("");
    setMobile("");
    setEmail("");
    setPassword("");
    setAgreed(false);
  };

  const handleRegistrationMethod = (method) => {
    setRegistrationMethod(method);
    setRegisterError("");

    clearFlatSelection();

    setFullName("");
    setMobile("");
    setEmail("");
    setPassword("");
    setAgreed(false);
  };

  const refreshAvailableFlats = async (
    blockId,
    floorNumber
  ) => {
    if (
      !community?.id ||
      !blockId ||
      floorNumber === null ||
      floorNumber === undefined
    ) {
      setAvailableFlats([]);
      return;
    }

    try {
      setAvailLoading(true);
      setRegisterError("");
      setSelectedFlatLabel("");
      setAvailableFlats([]);

      const communityRef = doc(
        db,
        "communities",
        community.id
      );

      const communitySnapshot =
        await getDoc(communityRef);

      if (!communitySnapshot.exists()) {
        throw new Error("Community not found.");
      }

      const communityData =
        communitySnapshot.data();

      const latestBlocks = Array.isArray(
        communityData.blocks
      )
        ? communityData.blocks
        : [];

      const selectedBlock = latestBlocks.find(
        (block) => block.id === blockId
      );

      if (!selectedBlock) {
        throw new Error(
          "Selected block not found."
        );
      }

      const allFlats = buildFlatsForFloor(
        selectedBlock,
        floorNumber
      );

      const occupancy =
        selectedBlock.occupancy || {};

      const available = allFlats.filter(
        (flatLabel) => !occupancy[flatLabel]
      );

      setAvailableFlats(available);
    } catch (error) {
      console.error(
        "Flat availability error:",
        error
      );

      setAvailableFlats([]);

      setRegisterError(
        error.message ||
          "Unable to load available flats."
      );
    } finally {
      setAvailLoading(false);
    }
  };

  const validateCommonFields = () => {
    if (!community?.id) {
      throw new Error(
        "Please fetch your community first."
      );
    }

    if (!selectedBlockId) {
      throw new Error(
        "Please select a block."
      );
    }

    if (selectedFloorNumber === null) {
      throw new Error(
        "Please select a floor."
      );
    }

    if (!selectedFlatLabel) {
      throw new Error(
        "Please select a flat number."
      );
    }

    if (!mobile.trim()) {
      throw new Error(
        "Please enter your mobile number."
      );
    }

    const mobilePattern = /^[0-9]{10}$/;

    if (!mobilePattern.test(mobile.trim())) {
      throw new Error(
        "Please enter a valid 10-digit mobile number."
      );
    }

    if (!agreed) {
      throw new Error(
        "Please agree to the Terms and Privacy Policy."
      );
    }

    const selectedBlock = blocks.find(
      (block) => block.id === selectedBlockId
    );

    if (!selectedBlock) {
      throw new Error(
        "Invalid block selection."
      );
    }

    return selectedBlock;
  };

  const saveResidentAndClaimFlat = async ({
    user,
    selectedBlock,
    authProvider,
    residentName,
    residentMobile,
  }) => {
    const communityRef = doc(
      db,
      "communities",
      community.id
    );

    const userRef = doc(
      db,
      "users",
      user.uid
    );

    await runTransaction(
      db,
      async (transaction) => {
        const communitySnapshot =
          await transaction.get(communityRef);

        const userSnapshot =
          await transaction.get(userRef);

        if (!communitySnapshot.exists()) {
          throw new Error(
            "Community not found during registration."
          );
        }

        const communityData =
          communitySnapshot.data();

        const communityBlocks =
          Array.isArray(communityData.blocks)
            ? [...communityData.blocks]
            : [];

        const blockIndex =
          communityBlocks.findIndex(
            (block) =>
              block.id === selectedBlockId
          );

        if (blockIndex < 0) {
          throw new Error(
            "Selected block was not found."
          );
        }

        const currentBlock = {
          ...communityBlocks[blockIndex],
        };

        const occupancy = {
          ...(currentBlock.occupancy || {}),
        };

        if (occupancy[selectedFlatLabel]) {
          throw new Error(
            "Selected flat is already occupied. Please choose another flat."
          );
        }

        const existingUser =
          userSnapshot.exists()
            ? userSnapshot.data()
            : {};

        if (
          existingUser.unit?.communityId &&
          existingUser.unit?.flatLabel
        ) {
          throw new Error(
            "This account is already registered with a flat. Please log in instead."
          );
        }

        const existingCommunities =
          Array.isArray(
            existingUser.communities
          )
            ? existingUser.communities
            : [];

        const updatedCommunities =
          Array.from(
            new Set([
              ...existingCommunities,
              community.id,
            ])
          );

        occupancy[selectedFlatLabel] =
          user.uid;

        currentBlock.occupancy = occupancy;

        communityBlocks[blockIndex] =
          currentBlock;

        transaction.update(communityRef, {
          blocks: communityBlocks,
        });

        transaction.set(
          userRef,
          {
            uid: user.uid,
            role: "resident",
            email: user.email || null,
            fullName:
              residentName?.trim() ||
              user.displayName ||
              null,
            mobile:
              residentMobile.trim(),
            photoURL:
              user.photoURL || null,
            communities:
              updatedCommunities,
            unit: {
              communityId: community.id,
              blockId: selectedBlockId,
              blockName:
                selectedBlock.name,
              floorNumber:
                selectedFloorNumber,
              flatLabel:
                selectedFlatLabel,
            },
            status: "pending",
            profileCompleted: true,
            authProvider,
            emailVerified:
              user.emailVerified,
            createdAt:
              existingUser.createdAt ||
              Timestamp.now(),
            updatedAt: Timestamp.now(),
          },
          {
            merge: true,
          }
        );
      }
    );
  };

  const handleEmailRegister = async () => {
    setRegisterError("");

    let createdUser = null;
    let registrationSaved = false;

    try {
      const selectedBlock =
        validateCommonFields();

      if (!fullName.trim()) {
        throw new Error(
          "Please enter your full name."
        );
      }

      if (!email.trim()) {
        throw new Error(
          "Please enter your email address."
        );
      }

      if (!password) {
        throw new Error(
          "Please enter your password."
        );
      }

      if (password.length < 6) {
        throw new Error(
          "Password must contain at least 6 characters."
        );
      }

      setRegistering(true);

      const userCredential =
        await createUserWithEmailAndPassword(
          auth,
          email.trim(),
          password
        );

      createdUser = userCredential.user;

      await updateProfile(createdUser, {
        displayName: fullName.trim(),
      });

      await saveResidentAndClaimFlat({
        user: createdUser,
        selectedBlock,
        authProvider: "password",
        residentName: fullName,
        residentMobile: mobile,
      });

      registrationSaved = true;

      try {
        await sendVerificationEmail(
          createdUser,
          community.id,
          fullName
        );
      } catch (verificationError) {
        console.error(
          "Verification email error:",
          verificationError
        );
      }

      navigate(
        `/check-email?community=${encodeURIComponent(
          community.id
        )}&email=${encodeURIComponent(
          email.trim()
        )}`
      );
    } catch (error) {
      console.error(
        "Email registration error:",
        error
      );

      if (
        createdUser &&
        !registrationSaved
      ) {
        try {
          await deleteUser(createdUser);
        } catch (deleteError) {
          console.warn(
            "Unable to delete new user:",
            deleteError
          );
        }
      }

      await signOut(auth).catch(() => {});

      setRegisterError(
        getAuthErrorMessage(error)
      );
    } finally {
      setRegistering(false);
    }
  };

  const handleGoogleRegister = async () => {
    setRegisterError("");

    let googleUser = null;
    let isNewGoogleUser = false;
    let registrationSaved = false;

    try {
      const selectedBlock =
        validateCommonFields();

      setGoogleRegistering(true);

      const result = await signInWithPopup(
        auth,
        googleProvider
      );

      googleUser = result.user;

      const additionalUserInfo =
        getAdditionalUserInfo(result);

      isNewGoogleUser = Boolean(
        additionalUserInfo?.isNewUser
      );

      await saveResidentAndClaimFlat({
        user: googleUser,
        selectedBlock,
        authProvider: "google",
        residentName:
          googleUser.displayName || "",
        residentMobile: mobile,
      });

      registrationSaved = true;

      navigate("/dashboard");
    } catch (error) {
      console.error(
        "Google registration error:",
        error
      );

      if (
        googleUser &&
        isNewGoogleUser &&
        !registrationSaved
      ) {
        try {
          await deleteUser(googleUser);
        } catch (deleteError) {
          console.warn(
            "Unable to delete new Google user:",
            deleteError
          );
        }
      }

      if (
        error?.message?.includes(
          "already registered with a flat"
        )
      ) {
        await signOut(auth).catch(() => {});
      }

      setRegisterError(
        getAuthErrorMessage(error)
      );
    } finally {
      setGoogleRegistering(false);
    }
  };

  const resetCommunity = () => {
    setCommunity(null);
    setCommunityId("");
    setFetchError("");
    setShowRegistrationChoice(false);
    setRegistrationMethod("");

    clearFlatSelection();

    setFullName("");
    setMobile("");
    setEmail("");
    setPassword("");
    setAgreed(false);
  };

  const renderPropertySelection = () => (
    <>
      <h5 className="mb-3">
        Choose Block, Floor and Flat
      </h5>

      <Row className="g-2">
        <Form.Group
          as={Col}
          xs={12}
          md={4}
          className="mb-3"
        >
          <Form.Label>Block</Form.Label>

          <Form.Select
            value={selectedBlockId}
            disabled={isSubmitting}
            onChange={(event) => {
              const blockId =
                event.target.value;

              setSelectedBlockId(blockId);
              setSelectedFloorNumber(null);
              setSelectedFlatLabel("");
              setAvailableFlats([]);
              setRegisterError("");
            }}
          >
            <option value="">
              Select block
            </option>

            {blocks.map((block) => (
              <option
                key={block.id}
                value={block.id}
              >
                {block.name} - Block
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group
          as={Col}
          xs={12}
          md={4}
          className="mb-3"
        >
          <Form.Label>Floor</Form.Label>

          <Form.Select
            value={
              selectedFloorNumber ?? ""
            }
            disabled={
              !selectedBlockId ||
              isSubmitting
            }
            onChange={async (event) => {
              const value =
                event.target.value;

              if (value === "") {
                setSelectedFloorNumber(null);
                setSelectedFlatLabel("");
                setAvailableFlats([]);
                return;
              }

              const floorNumber =
                Number(value);

              setSelectedFloorNumber(
                floorNumber
              );

              setSelectedFlatLabel("");
              setAvailableFlats([]);

              await refreshAvailableFlats(
                selectedBlockId,
                floorNumber
              );
            }}
          >
            <option value="">
              Select floor
            </option>

            {floorOptions.map(
              ({
                label,
                floorNumber,
              }) => (
                <option
                  key={`floor-${floorNumber}`}
                  value={floorNumber}
                >
                  {label}
                </option>
              )
            )}
          </Form.Select>
        </Form.Group>

        <Form.Group
          as={Col}
          xs={12}
          md={4}
          className="mb-3"
        >
          <Form.Label>
            Flat Number
          </Form.Label>

          <Form.Select
            value={selectedFlatLabel}
            disabled={
              !selectedBlockId ||
              selectedFloorNumber === null ||
              availLoading ||
              isSubmitting
            }
            onChange={(event) => {
              setSelectedFlatLabel(
                event.target.value
              );

              setRegisterError("");
            }}
          >
            <option value="">
              {availLoading
                ? "Checking availability..."
                : availableFlats.length === 0
                ? "No available flats"
                : "Select available flat"}
            </option>

            {availableFlats.map(
              (flatLabel) => (
                <option
                  key={flatLabel}
                  value={flatLabel}
                >
                  {flatLabel}
                </option>
              )
            )}
          </Form.Select>

          {!availLoading &&
            selectedFloorNumber !== null &&
            availableFlats.length === 0 && (
              <Form.Text className="text-danger">
                No flats are currently
                available on this floor.
              </Form.Text>
            )}
        </Form.Group>
      </Row>
    </>
  );

  return (
    <Container
      className="py-4 py-md-5"
      style={{ minHeight: "100vh" }}
    >
      <Row className="justify-content-center">
        <Col xs={12} lg={10} xl={9}>
          <Card className="overflow-hidden shadow register-card rounded-4">
            <Row className="g-0">
              <Col
                md={5}
                className="d-none d-md-block"
              >
                <div className="register-visual h-100">
                  {IMAGE_URL}

                  <div className="register-visual-overlay">
                    <div className="register-visual-text">
                      <h2 className="mb-1">
                        Join your community
                      </h2>

                      <p className="mb-0">
                        Simple registration.
                        Secure access.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={7}>
                <Card.Body className="p-3 p-md-4">
                  <h2 className="mb-1">
                    Resident Registration
                  </h2>

                  <p className="text-muted mb-4">
                    Find your community and
                    choose how you want to
                    register.
                  </p>

                  <section className="mb-4 pb-3 border-bottom">
                    <h5 className="mb-3">
                      Step 1: Identify Your Community
                    </h5>

                    {fetchError && (
                      <Alert variant="danger">
                        {fetchError}
                      </Alert>
                    )}

                    {!community ? (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Community ID
                          </Form.Label>

                          <Form.Control
                            type="text"
                            placeholder="e.g., ABC12345"
                            value={communityId}
                            onChange={(event) =>
                              setCommunityId(
                                event.target.value.toUpperCase()
                              )
                            }
                            onKeyDown={(event) => {
                              if (
                                event.key === "Enter"
                              ) {
                                handleFetch();
                              }
                            }}
                          />
                        </Form.Group>

                        <Button
                          className="primary-cta"
                          onClick={handleFetch}
                          disabled={fetching}
                        >
                          {fetching ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                              />
                              Fetching...
                            </>
                          ) : (
                            "Fetch Community"
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Alert variant="info">
                          <div>
                            <strong>
                              Community ID:
                            </strong>{" "}
                            <code>
                              {community.id}
                            </code>
                          </div>

                          <div>
                            <strong>Name:</strong>{" "}
                            {community.data.name}
                          </div>

                          <div>
                            <strong>
                              Address:
                            </strong>{" "}
                            {community.data.address}
                          </div>

                          {community.data
                            .description && (
                            <div>
                              <strong>
                                Description:
                              </strong>{" "}
                              {
                                community.data
                                  .description
                              }
                            </div>
                          )}
                        </Alert>

                        <div className="d-flex flex-wrap gap-2">
                          <Button
                            variant="outline-secondary"
                            onClick={
                              resetCommunity
                            }
                            disabled={
                              isSubmitting
                            }
                          >
                            Check Another Community
                          </Button>

                          {!showRegistrationChoice && (
                            <Button
                              className="primary-cta"
                              onClick={
                                handleProceedToRegister
                              }
                              disabled={
                                isSubmitting
                              }
                            >
                              Proceed to Register
                            </Button>
                          )}
                        </div>
                      </>
                    )}
                  </section>

                  {community &&
                    showRegistrationChoice && (
                      <section>
                        <h5 className="mb-3">
                          Step 2: Choose Registration Method
                        </h5>

                        <Row className="g-3 mb-4">
                          <Col xs={12} md={6}>
                            <Button
                              type="button"
                              variant={
                                registrationMethod ===
                                "email"
                                  ? "primary"
                                  : "outline-primary"
                              }
                              className="w-100 py-3"
                              disabled={
                                isSubmitting
                              }
                              onClick={() =>
                                handleRegistrationMethod(
                                  "email"
                                )
                              }
                            >
                              <div className="fw-semibold">
                                Register with Email
                              </div>

                              <small>
                                Use email and password
                              </small>
                            </Button>
                          </Col>

                          <Col xs={12} md={6}>
                            <Button
                              type="button"
                              variant={
                                registrationMethod ===
                                "google"
                                  ? "danger"
                                  : "outline-danger"
                              }
                              className="w-100 py-3"
                              disabled={
                                isSubmitting
                              }
                              onClick={() =>
                                handleRegistrationMethod(
                                  "google"
                                )
                              }
                            >
                              <div className="fw-semibold">
                                Register with Google
                              </div>

                              <small>
                                Continue with Gmail
                              </small>
                            </Button>
                          </Col>
                        </Row>

                        {!registrationMethod && (
                          <Alert variant="light">
                            Select a registration
                            method to continue.
                          </Alert>
                        )}

                        {registrationMethod ===
                          "email" && (
                          <>
                            <div className="border rounded-3 p-3">
                              <h5 className="mb-3 text-primary">
                                Email Registration
                              </h5>

                              {renderPropertySelection()}

                              <hr />

                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Full Name
                                </Form.Label>

                                <Form.Control
                                  type="text"
                                  value={fullName}
                                  disabled={
                                    isSubmitting
                                  }
                                  placeholder="e.g., Rahul Sharma"
                                  onChange={(
                                    event
                                  ) =>
                                    setFullName(
                                      event.target
                                        .value
                                    )
                                  }
                                />
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Mobile Number
                                </Form.Label>

                                <Form.Control
                                  type="tel"
                                  value={mobile}
                                  maxLength={10}
                                  disabled={
                                    isSubmitting
                                  }
                                  placeholder="e.g., 9876543210"
                                  onChange={(
                                    event
                                  ) =>
                                    setMobile(
                                      event.target.value.replace(
                                        /\D/g,
                                        ""
                                      )
                                    )
                                  }
                                />
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Email
                                </Form.Label>

                                <Form.Control
                                  type="email"
                                  value={email}
                                  disabled={
                                    isSubmitting
                                  }
                                  autoComplete="username"
                                  placeholder="name@example.com"
                                  onChange={(
                                    event
                                  ) =>
                                    setEmail(
                                      event.target
                                        .value
                                    )
                                  }
                                />
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Password
                                </Form.Label>

                                <Form.Control
                                  type="password"
                                  value={password}
                                  disabled={
                                    isSubmitting
                                  }
                                  autoComplete="new-password"
                                  placeholder="Minimum 6 characters"
                                  onChange={(
                                    event
                                  ) =>
                                    setPassword(
                                      event.target
                                        .value
                                    )
                                  }
                                />
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Check
                                  id="email-agree-terms"
                                  type="checkbox"
                                  checked={agreed}
                                  disabled={
                                    isSubmitting
                                  }
                                  label="I agree to the Terms and Privacy Policy."
                                  onChange={(
                                    event
                                  ) =>
                                    setAgreed(
                                      event.target
                                        .checked
                                    )
                                  }
                                />
                              </Form.Group>

                              {registerError && (
                                <Alert variant="danger">
                                  {registerError}
                                </Alert>
                              )}

                              <div className="d-grid">
                                <Button
                                  className="primary-cta"
                                  disabled={
                                    isSubmitting
                                  }
                                  onClick={
                                    handleEmailRegister
                                  }
                                >
                                  {registering ? (
                                    <>
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        className="me-2"
                                      />
                                      Registering...
                                    </>
                                  ) : (
                                    "Create Account with Email"
                                  )}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        {registrationMethod ===
                          "google" && (
                          <>
                            <div className="border rounded-3 p-3">
                              <h5 className="mb-2 text-danger">
                                Google Registration
                              </h5>

                              <p className="text-muted">
                                Your full name, email,
                                and profile photo will
                                be taken from your
                                selected Google account.
                              </p>

                              {renderPropertySelection()}

                              <hr />

                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Mobile Number
                                </Form.Label>

                                <Form.Control
                                  type="tel"
                                  value={mobile}
                                  maxLength={10}
                                  disabled={
                                    isSubmitting
                                  }
                                  placeholder="e.g., 9876543210"
                                  onChange={(
                                    event
                                  ) =>
                                    setMobile(
                                      event.target.value.replace(
                                        /\D/g,
                                        ""
                                      )
                                    )
                                  }
                                />

                                <Form.Text muted>
                                  The mobile number is
                                  saved with your
                                  resident profile.
                                </Form.Text>
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Check
                                  id="google-agree-terms"
                                  type="checkbox"
                                  checked={agreed}
                                  disabled={
                                    isSubmitting
                                  }
                                  label="I agree to the Terms and Privacy Policy."
                                  onChange={(
                                    event
                                  ) =>
                                    setAgreed(
                                      event.target
                                        .checked
                                    )
                                  }
                                />
                              </Form.Group>

                              {registerError && (
                                <Alert variant="danger">
                                  {registerError}
                                </Alert>
                              )}

                              <div className="d-grid">
                                <Button
                                  type="button"
                                  variant="danger"
                                  disabled={
                                    isSubmitting
                                  }
                                  onClick={
                                    handleGoogleRegister
                                  }
                                >
                                  {googleRegistering ? (
                                    <>
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        className="me-2"
                                      />
                                      Connecting to Google...
                                    </>
                                  ) : (
                                    "Continue with Google"
                                  )}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </section>
                    )}

                  <p className="mt-4 mb-0 text-muted">
                    Your safety is our prime priority.
                  </p>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}